<template>
<div style="height:100%">
    <div id="cesiumContainer">
    </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widget from "cesium/Widgets/widgets.css";

export default {
    mounted () {
        var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
      this.init();
    },
    methods : {
        init () {
            var viewerOption = {
                    geocoder: true, // 地理位置查询定位控件
                    homeButton: true, // 默认相机位置控件
                    timeline: false, // 时间滚动条控件
                    navigationHelpButton: true, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: true, // 底图切换控件
                    animation: false, // 控制场景动画的播放速度控件
                    shouldAnimate: true,
                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                    }),
                };
            let viewer= new Cesium.Viewer('cesiumContainer',viewerOption);
                viewer._cesiumWidget._creditContainer.style.display='none';

                //添加图标
            var icon1=viewer.entities.add({
                position : Cesium.Cartesian3.fromDegrees(-75.170726, 39.9208667),
                billboard :{
                   name:'icon1',
                   image  : require('../../assets/marks/mark1.png'),
                   verticalOrigin : Cesium.VerticalOrigin.BOTTOM
                },
                
            });
            var icon2=viewer.entities.add({
                position:Cesium.Cartesian3.fromDegrees(-75.1698529, 39.9220071),
                billboard:{
                    name:'icon2',
                    image:require('../../assets/marks/mark2.png'),
                }
            });
            var icon3=viewer.entities.add({
                position:Cesium.Cartesian3.fromDegrees(-75.1705217, 39.921786),
                billboard:{
                    name:'icon2',
                    image:require('../../assets/marks/mark3.png'),
                }
            });
             var icon4=viewer.entities.add({
                position:Cesium.Cartesian3.fromDegrees(-75.1698606, 39.921127),
                billboard:{
                    name:'icon4',
                    image:require('../../assets/marks/mark4.png'),
                     verticalOrigin : Cesium.VerticalOrigin.BOTTOM
                }
            })
            //全部加载完成后，再缩放
               Cesium.when.all([icon1,icon2,icon3,icon4], function(pins){
               viewer.zoomTo(pins);
            });
        }
    }
}
</script>
<style scoped>
     #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>